import { useLocation } from 'react-router-dom';
import s from "./Dynmap.module.scss";

export default function Dynmap() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const server: string | undefined = queryParams.get('server') || undefined;

    let src;
    if (server && server !== "archives") {
        src = `https://atownyserver.com/dynmap/${server}/`;
    } else {
        src = "https://archive.atownyserver.com"
    }

    return (<iframe className={s.fullFrame} src={src} />);
}